import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { ModalEnum } from 'myParkdUtils/enums';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlug } from '@fortawesome/free-solid-svg-icons';
import * as telematicAccountsActions from 'features/telematics/telematicAccountsActions';
import * as modalWindowActions from 'root/modal/modalWindowActions';


const TelematicAccountsForm = (props) => {

    useEffect(() => {
        props.getCompanyTelematicAccounts();
    }, []);

    return (
        <div className="radius-rectangle settings-box">
            <div className="settings-box-header">
                <h3 className="bold-title">
                    <FontAwesomeIcon icon={faPlug} className="icon-before" />
                    <FormattedMessage id="TELEMATIC_CONNECTIONS" values={{ numAccounts: props.companyTelematicAccounts.accounts.length }} />
                </h3>
            </div>

            <div className="settings-box-content">
                {props.companyTelematicAccounts.succeeded && (
                    <React.Fragment>
                        {!!props.companyTelematicAccounts.accounts.length && (
                            <div style={{ marginBottom: '20px' }}>
                                <ul id="connected-telematic-accounts-list">
                                    {props.companyTelematicAccounts.accounts.map((account, i) => (
                                        <li key={i} className={'connection-option ' + account?.type}>
                                            {account?.displayName}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        <button type="button" className="btn-blue" onClick={() => props.updateModal(ModalEnum.CHOOSE_CONNECTION)}>
                            <FormattedMessage id="REQUEST_CONNECTION" />
                        </button>
                    </React.Fragment>
                )}

                {props.companyTelematicAccounts.error && (
                    <div className="error-box">
                        <FormattedMessage id="ERROR_SOMETHING_WENT_WRONG" />
                    </div>
                )}
            </div>
        </div>
    );
};

function mapStateToProps(state, props) {
    return {
        companyTelematicAccounts: state.companyTelematicAccounts,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            getCompanyTelematicAccounts: telematicAccountsActions.getCompanyTelematicAccounts,
            updateModal: modalWindowActions.updateModalWindow,
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(TelematicAccountsForm);
